(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContractProfilDeleteController',ContractProfilDeleteController);

    ContractProfilDeleteController.$inject = ['$uibModalInstance', 'entity', 'ContractProfil'];

    function ContractProfilDeleteController($uibModalInstance, entity, ContractProfil) {
        var vm = this;
        vm.contractProfil = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ContractProfil.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
